<template><svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 45.977 45.977"
>
		<path d="M29.355,33.836c-7.691-0.977-13.836-7.248-14.674-14.957c-0.771-7.092,2.827-13.418,8.436-16.642
			c1.09-0.626,0.639-2.296-0.617-2.236c-1.406,0.067-2.841,0.269-4.297,0.622C8.505,2.982,1.286,11.459,0.63,21.419
			c-0.882,13.409,9.731,24.557,22.949,24.557c10.078,0,18.639-6.481,21.748-15.504c0.414-1.203-1.062-2.112-1.979-1.23
			C39.804,32.644,34.792,34.526,29.355,33.836z"/>
</svg>
</template>